import React from 'react';
import type { SidebarContentProps } from '../types.js';
import { TabsHeader } from './TabsHeader.js';
import { TabsBar } from './TabsBar.js';
import { ChatList } from './ChatList.js';
import { SIDEBAR_LAYOUT } from '../../../styles/sidebar-layout.js';

/**
 * Sidebar content component
 * Shared between mobile and desktop layouts
 * Composes header, tabs, and chat list
 */
export const SidebarContent: React.FC<SidebarContentProps> = ({
  onCreateChat,
  onChatHistoryClick,
  chats,
  selectedChatId,
  onSelectChat,
  onRestoreChat,
  onDeleteChat,
  onDeleteAllChats,
  activeTab,
  setActiveTab,
  tabs,
  filteredChats,
  loadTriggerRef,
  hasMoreChats,
  isLoadingMoreChats,
  truncateTitle,
  formatDate,
  onOpenSettings,
  onOpenCapabilities,
  mcpConnectionsHref,
  routinesHref,
  onToggleCollapse,
  isCollapsed,
  onClose,
  compactMode = false,
  meridianLogoUrl = '/meridian.png',
  forceDesktopHeader = false,
}) => {
  return (
    <div className={SIDEBAR_LAYOUT.desktopContent}>
      {/* Header */}
      <TabsHeader
        onChatHistoryClick={onChatHistoryClick}
        onCreateChat={onCreateChat}
        onDeleteAllChats={onDeleteAllChats}
        hasChats={chats.length > 0}
        onOpenSettings={onOpenSettings}
        onOpenCapabilities={onOpenCapabilities}
        mcpConnectionsHref={mcpConnectionsHref}
        routinesHref={routinesHref}
        onToggleCollapse={onToggleCollapse}
        isCollapsed={isCollapsed}
        onClose={onClose}
        meridianLogoUrl={meridianLogoUrl}
        forceDesktopHeader={forceDesktopHeader}
      />

      {/* Tabs */}
      {!isCollapsed && (
        <TabsBar
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          compactMode={compactMode}
        />
      )}

      {/* Chat List */}
      {!isCollapsed && (
        <ChatList
          filteredChats={filteredChats}
          selectedChatId={selectedChatId}
          onSelectChat={onSelectChat}
          onRestoreChat={onRestoreChat}
          onDeleteChat={onDeleteChat}
          activeTab={activeTab}
          loadTriggerRef={loadTriggerRef}
          hasMoreChats={hasMoreChats}
          isLoadingMoreChats={isLoadingMoreChats}
          truncateTitle={truncateTitle}
          formatDate={formatDate}
          compactMode={compactMode}
        />
      )}
    </div>
  );
};
